var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListView',{attrs:{"cols":"12","sm":"6","md":"3","items":_vm.cursor.items,"loading":_vm.cursor.loading,"empty-text":_vm.$t('listview.no_following')},on:{"bottom-reached":_vm.cursor.loadItems},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('section',{staticClass:"px-2 py-2"},[_c('UserCard',{attrs:{"user":item}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }